
import { useState } from 'react';

export default function Services() {
  const [hoveredCard, setHoveredCard] = useState<number | null>(1);

  const services = [
    {
      id: 0,
      title: 'Reformas Integrales',
      description: 'Cocinas, baños, viviendas completas',
      image: 'https://public.readdy.ai/ai/img_res/d59f950f5fa766271c62f1f3d39fea4c.jpg'
    },
    {
      id: 1,
      title: 'Construcción Nueva',
      description: 'Proyectos llave en mano, desde cimentación hasta acabados finales',
      image: 'https://readdy.ai/api/search-image?query=New%20residential%20building%20construction%20in%20progress%2C%20modern%20architecture%20structure%2C%20concrete%20framework%2C%20construction%20workers%2C%20professional%20building%20site%2C%20clear%20sky%2C%20showing%20quality%20construction%20process%20from%20foundation%20to%20completion&width=700&height=800&seq=service-construccion&orientation=portrait'
    },
    {
      id: 2,
      title: 'Mantenimiento',
      description: 'Reparaciones y conservación de edificios',
      image: 'https://readdy.ai/api/search-image?query=Professional%20maintenance%20work%20on%20building%20facade%2C%20workers%20performing%20repairs%20and%20conservation%2C%20scaffolding%2C%20building%20maintenance%20equipment%2C%20quality%20service%20photography%20showing%20care%20and%20attention%20to%20property%20preservation&width=600&height=800&seq=service-mantenimiento&orientation=portrait'
    }
  ];

  return (
    <section id="servicios" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-20">
          Nuestros Servicios 🏗️
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {services.map((service) => (
            <div
              key={service.id}
              className={`relative rounded-2xl overflow-hidden cursor-pointer transition-all duration-500 ${
                hoveredCard === service.id ? 'md:scale-105' : 'md:scale-100'
              }`}
              style={{ height: '500px' }}
              onMouseEnter={() => setHoveredCard(service.id)}
              onMouseLeave={() => setHoveredCard(1)}
            >
              <img 
                src={service.image}
                alt={service.title}
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent"></div>
              
              <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                <h3 className="text-2xl font-bold mb-3">{service.title}</h3>
                <p className={`text-base text-white/90 transition-all duration-300 ${
                  hoveredCard === service.id ? 'opacity-100 max-h-20' : 'opacity-80 max-h-12'
                }`}>
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
